(function () {
  var SELECTORS = {
    planSelector: '[data-plan-selector]',
    planCard: '.plan-card',
    planBadgeText: '[data-plan-badge-text]',
    planInput: '[data-plan-input]'
  };

  var SHOPIFY_FORM_FIELD_SELECTOR = '[id="custom#support_plan"]';

  var SHOPIFY_FORM_STYLES = [
    ':host {',
    '  --container-max-w: 100% !important;',
    '  --inline-container-max-width: 100% !important;',
    '  --inline-form-alignment: stretch !important;',
    '  --forms-padding-top: 0 !important;',
    '  --forms-padding-right: 0 !important;',
    '  --forms-padding-bottom: 0 !important;',
    '  --forms-padding-left: 0 !important;',
    '}',
    '[data-sizing="form-wrapper"] { max-width: 100% !important; }',
    '[data-testid="form"] {',
    '  display: grid !important;',
    '  grid-template-columns: 1fr 1fr !important;',
    '  gap: 16px !important;',
    '  padding: 0 3px !important;',
    '}',
    '[data-testid="form"] > * { min-width: 0; }',
    '[data-testid="form"] > :has([id="custom#support_plan"]) {',
    '  position: absolute !important;',
    '  width: 1px !important; height: 1px !important;',
    '  overflow: hidden !important; clip: rect(0,0,0,0) !important;',
    '  white-space: nowrap !important; border: 0 !important;',
    '  padding: 0 !important; margin: -1px !important;',
    '}',
    '[data-testid="form"] > :first-child { grid-column: 1 / -1; }',
    '[data-testid="form"] > :has(textarea) { grid-column: 1 / -1; }',
    '[data-testid="form"] > output[role="alert"] { display: none !important; }',
    '[data-testid="form"] input, [data-testid="form"] textarea, [data-testid="form"] button, [data-testid="form"] label { font-family: inherit !important; }',
    '[data-testid="btn-form-submit"] { grid-column: 1 / -1 !important; justify-self: start !important; font-weight: bold !important; }',
    '[aria-controls="country-selector-dropdown"] { max-height: 100% !important; }',
    '[class*="formDisclaimer"] { text-align: left !important; }',
    ':host { --container-text-alignment: left !important; }',
    '@media (max-width: 749px) {',
    '  [data-testid="form"] { grid-template-columns: 1fr !important; }',
    '}'
  ].join('\n');

  function deepQuery(root, selector) {
    var match = root.querySelector(selector);
    if (match) return { el: match, shadowRoot: root };
    var children = root.querySelectorAll('*');
    for (var i = 0; i < children.length; i++) {
      if (children[i].shadowRoot) {
        var result = deepQuery(children[i].shadowRoot, selector);
        if (result) return result;
      }
    }
    return null;
  }

  function findShopifyFormField(section) {
    var result = deepQuery(section, SHOPIFY_FORM_FIELD_SELECTOR);
    return result ? result.el : null;
  }

  function injectStyles(section) {
    var result = deepQuery(section, SHOPIFY_FORM_FIELD_SELECTOR);
    if (!result) return false;
    var root = result.shadowRoot;
    if (root.querySelector('[data-osq-styles]')) return true;
    var style = document.createElement('style');
    style.setAttribute('data-osq-styles', '');
    style.textContent = SHOPIFY_FORM_STYLES;
    root.appendChild(style);
    return true;
  }

  function setFieldValue(field, value) {
    var nativeSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype, 'value'
    );
    if (nativeSetter && nativeSetter.set) {
      nativeSetter.set.call(field, value);
    } else {
      field.value = value;
    }
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getActivePlanName(section) {
    var active = section.querySelector('.plan-card--active');
    return active ? active.getAttribute('data-plan-name') : '';
  }

  function prefillShopifyForm(section) {
    var field = findShopifyFormField(section);
    if (field) {
      injectStyles(section);
      var planName = getActivePlanName(section);
      if (planName) setFieldValue(field, planName);
      return;
    }

    var observer = new MutationObserver(function () {
      var f = findShopifyFormField(section);
      if (f) {
        observer.disconnect();
        injectStyles(section);
        var name = getActivePlanName(section);
        if (name) setFieldValue(f, name);
      }
    });
    observer.observe(section, { childList: true, subtree: true });
  }

  function initPlanSelector(container) {
    var cards = container.querySelectorAll(SELECTORS.planCard);
    var section = container.closest('.shopify-section');
    if (!section) return;

    var badgeText = section.querySelector(SELECTORS.planBadgeText);
    var planInput = section.querySelector(SELECTORS.planInput);

    prefillShopifyForm(section);

    function selectPlan(card) {
      cards.forEach(function (c) {
        c.classList.remove('plan-card--active');
        c.setAttribute('aria-checked', 'false');
      });
      card.classList.add('plan-card--active');
      card.setAttribute('aria-checked', 'true');

      var planName = card.getAttribute('data-plan-name');
      if (badgeText) badgeText.textContent = planName;
      if (planInput) planInput.value = planName;

      var shopifyFormField = findShopifyFormField(section);
      if (shopifyFormField) setFieldValue(shopifyFormField, planName);
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectPlan(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectPlan(card);
        }
      });
    });
  }

  document.querySelectorAll(SELECTORS.planSelector).forEach(initPlanSelector);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var container = e.target.querySelector(SELECTORS.planSelector);
      if (container) initPlanSelector(container);
    });
  }
})();
